export const formatTime = (timeString: string): string => {
  const [hours, minutes] = timeString.split(':');
  const date = new Date();
  date.setHours(Number(hours));
  date.setMinutes(Number(minutes));

  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };
  return date.toLocaleTimeString([], options);
};

export const getBaseName = (
  filename: string,
): { name: string; ext: string } => {
  const lastDot = filename.lastIndexOf('.');
  if (lastDot === -1) {
    return { name: filename, ext: '' };
  }

  const ext = filename.slice(lastDot + 1);
  const known = ['pdf', 'doc', 'docx'];

  // Only treat it as an extension if it's a known one
  if (known.includes(ext.toLowerCase())) {
    return {
      name: filename.slice(0, lastDot),
      ext: `.${ext}`,
    };
  }

  // Otherwise, treat the full thing as the name
  return { name: filename, ext: '' };
};
